const serverUrl = 'https://rest.saobaar.com'
// const serverUrl = 'http://192.168.101.100:20001'
const fileUrl = 'https://file.cdyssjkj.com:20002'
// const serverUrl = 'http://localhost:20001'
const mediaUrl = 'https://media.cdyssjkj.com'

const productMdseStateListMini = [{
  value: 101,
  label: '上架（多端通用）'
}, {
  value: 102,
  label: '上架（个人用户可见）'
}, {
  value: 103,
  label: '上架（企业用户可见）'
}, {
  value: 201,
  label: '下架产品'
}]
const productMdseStateList = [{
  value: 0,
  label: '全部'
}, {
  value: 101,
  label: '上架（多端通用）'
}, {
  value: 102,
  label: '上架（个人用户可见）'
}, {
  value: 103,
  label: '上架（企业用户可见）'
}, {
  value: 201,
  label: '下架产品'
}]
const orderPaymentType = [{
  value: -1,
  label: '全部'
}, {
  value: 100,
  label: '支付宝'
}, {
  value: 101,
  label: '微信支付'
}, {
  value: 111,
  label: '积分支付'
}, {
  value: 1001,
  label: '测试模式支付'
}]
const orderStatePayment = [{
  value: -1,
  label: '全部'
}, {
  value: 0,
  label: '未支付'
}, {
  value: 1,
  label: '支付成功'
}, {
  value: 2,
  label: '支付失败'
}]
const productMdsePeriodUnit = [{
  value: 2,
  label: '个月'
}]
const productMdseAlbumLevel = [{
  value: 0,
  label: '家庭版'
}, {
  value: 1,
  label: '专业版'
}]

const title = '扫吧AR内部后台'
export default {
  serverUrl,
  mediaUrl,
  fileUrl,
  productMdseStateListMini,
  productMdseStateList,
  orderPaymentType,
  orderStatePayment,
  productMdsePeriodUnit,
  productMdseAlbumLevel,
  title
}



// WEBPACK FOOTER //
// ./src/config/global.js